import { AppState } from '../app/types';
import { ModuleData, ModuleId } from '../content';
import { GroupId } from '../config/systemConfig';
import { getWeakestFamiliesGlobal } from '../mastery';
export type DailyChallengeType = 'meester' | 'snelheid' | 'mix';
export interface DailyChallenge {
  id: string;
  type: DailyChallengeType;
  title: string;
  description: string;
  icon: string;
  targetCount: number;
  currentCount: number;
  rewardXP: number;
  moduleId?: ModuleId;
  isCompleted: boolean;
}

/**
 * Generates a deterministic daily challenge based on the current date.
 */
export function getTodayChallenge(state: AppState, modules: ModuleData[], selectedGroup: GroupId): DailyChallenge {
  const today = new Date();
  const dateString = today.toISOString().split('T')[0];

  // Deterministic rotation based on day of year
  const start = new Date(today.getFullYear(), 0, 0);
  const diff = today.getTime() - start.getTime();
  const oneDay = 1000 * 60 * 60 * 24;
  const dayOfYear = Math.floor(diff / oneDay);
  const types: DailyChallengeType[] = ['meester', 'snelheid', 'mix'];
  const type = types[dayOfYear % types.length];

  // Default values
  let title = 'Dagelijkse Uitdaging';
  let description = 'Voltooi de uitdaging voor bonus XP!';
  let icon = '🎯';
  let targetCount = 5;
  let moduleId: ModuleId | undefined = undefined;

  // Customize based on type
  switch (type) {
    case 'meester':
      {
        title = 'Meester-uitdaging';
        icon = '👑';
        targetCount = 5;

        // Find weakest subject
        if (state.familyMastery) {
          const weakest = getWeakestFamiliesGlobal(state.familyMastery, selectedGroup, 1);
          if (weakest.length > 0) {
            // Extract module ID from family ID (e.g., 'REK-CIJF-PLUS' -> 'REK')
            const familyId = weakest[0].familyId;
            const modId = familyId.split('-')[0] as ModuleId;
            const module = modules.find(m => m.id === modId);
            if (module) {
              moduleId = module.id;
              description = `Beantwoord ${targetCount} vragen correct in ${module.title}`;
            }
          }
        }
        if (!moduleId) {
          description = `Beantwoord ${targetCount} vragen correct in een willekeurig vak`;
        }
        break;
      }
    case 'snelheid':
      {
        title = 'Snelheidsronde';
        icon = '⚡';
        targetCount = 5;
        description = `Beantwoord vandaag ${targetCount} vragen`;
        break;
      }
    case 'mix':
      {
        title = 'Mix-challenge';
        icon = '🎨';
        targetCount = 3;
        description = `Oefen vandaag in ${targetCount} verschillende vakken`;
        break;
      }
  }

  // Check state for progress
  const challengeState = state.dailyChallenge;
  const isToday = challengeState?.lastChallengeDate === dateString;
  const currentCount = isToday ? challengeState?.progress || 0 : 0;
  const isCompleted = isToday ? challengeState?.completedToday || false : false;
  return {
    id: `dc-${dateString}`,
    type,
    title,
    description,
    icon,
    targetCount,
    currentCount: Math.min(currentCount, targetCount),
    rewardXP: 50,
    moduleId,
    isCompleted
  };
}